import script from "./leaseLog.vue?vue&type=script&setup=true&lang=js"
export * from "./leaseLog.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__